$(document).ready(function(){
  

//     if($("#min-val").val() == ''){
//       var min = parseInt($("#min-val").attr('min'));
//     }else{
//       var min = parseInt($("#min-val").val());
//     }
//     if($("#max-val").val() == ''){
//       var max = parseInt($("#max-val").attr('max'));
//     }else{
//       var max = parseInt($("#max-val").val());
//     }
//     var def_min = parseInt($('#min-val').attr('min'));
//     var def_max = parseInt($('#max-val').attr('max'));
    
//    console.log(def_min,def_max,min,max);

//   function RangeSlider(min,max,def_min,def_max){
//     var slider = document.getElementById('slider');
//     noUiSlider.create(slider, {
//         start: [min, max],
//         connect: true,
//         range: {
//             'min': def_min,
//             'max': def_max
//         }
//     });
    
//   var snapValues = [
//       document.getElementById('min-val'),
//       document.getElementById('max-val')
//   ];
//     slider.noUiSlider.on('update', function (values,handle) {
//         snapValues[handle].value = values[handle]; 
//     });     
//   }
//  RangeSlider(min,max,def_min,def_max);

 
//    $('body').on('change','input[type="number"]',function(){
//     var min_value = $("#min-val").val();
//     var max_value = $("#max-val").val();
//     slider.noUiSlider.set([min_value, max_value]);
//   });


    $('body').on('click','.slideout__button',function(e){
        e.preventDefault();
        $('.collection-sidebar').addClass('active');
        $('body').addClass('overflow-hidden'); 
    });
  
    $('body').on('click','.filter-group-summary',function(){
      $(this).parents('.filter-group').find('.filter-group-display').toggleClass('open');
    });


    $('body').on('click','.filter-close,.overlay-filter',function(){
       $('.collection-sidebar').removeClass('active');
       $('body').removeClass('overflow-hidden'); 
    });
 
    $('body').on('click','.active-fillter-remove',function(e){
      e.preventDefault();
      var path = $(this).attr('href');
      var paramsup = {
      type: 'GET',
      url: path,
      success: function(data) { 
        window.history && window.history.pushState && window.history.pushState("", "", path);
        var content = $(data).find('.fillter_wrpper').html();
        $('.fillter_wrpper').html(content);
        var grid = $(data).find('.results--container').html();
        var filters = $(data).find('[data-filters-options]').html();
        $('.results--container').html(grid);
        $('[data-filters-options]').html(filters);

      // if($(data).find("#fillter_min").val() == ''){
      //   var min = parseInt($("#fillter_min").attr('min'));
      // }else{
      //   var min = parseInt($("#fillter_min").val());
      // }
      // if($(data).find("#fillter_max").val() == ''){
      //   var max = parseInt($("#fillter_max").attr('max'));
      // }else{
      //   var max = parseInt($("#fillter_max").val());
      // }
      // var def_min = parseInt($("#fillter_min").attr('min'));
      // var def_max = parseInt($("#fillter_max").attr('max'));

      $('.results--container img[data-rimg="lazy"]').each(function () {
          $(this).attr('srcset', $(this).attr('src'));
          $(this).attr('data-rimg', 'loaded');
      });

       reinitializeProductCards();

      },
      error: function() {
      }
    };
    $.ajax(paramsup);
    return false; 
  });


    $('body').on('change', 'input[type="checkbox"], input[type="number"]', function () {
      var form_data = $(this).closest('form').serialize(); 
      var path = window.location.pathname;
      var paramsup = {
      type: 'GET',
      url: path+'?'+form_data,
      success: function(data) {
        $('body').removeClass('overflow-hidden');  
        window.history && window.history.pushState && window.history.pushState("", "", path+'?'+form_data);
        var content = $(data).find('.fillter_wrpper').html();
       
        $('.fillter_wrpper').html(content);
        var grid = $(data).find('.results--container').html();
        
        var filters = $(data).find('[data-filters-options]').html();
        $('.results--container').html(grid);
        $('[data-filters-options]').html(filters);


      $('.results--container img[data-rimg="lazy"]').each(function () {
          $(this).attr('srcset', $(this).attr('src'));
          $(this).attr('data-rimg', 'loaded');
      });

      reinitializeProductCards();
        
      },
      error: function() {
      }
    };
    $.ajax(paramsup);
    return false;   
  });

    $('body').on('change','.sort-by',function(){
      var form_data = $('#filterForm').serialize();
      var path = window.location.pathname;
      var paramsup = {
      type: 'GET',
      url: path+'?'+form_data,
      success: function(data) { 
          window.history && window.history.pushState && window.history.pushState("", "", path+'?'+form_data);
          var content = $(data).find('.fillter_wrpper').html();
          $('.fillter_wrpper').html(content);
          var grid = $(data).find('.results--container').html();
          var filters = $(data).find('[data-filters-options]').html();
          $('.results--container').html(grid);
          $('[data-filters-options]').html(filters);
        if($(data).find("#fillter_min").val() == ''){
          var min = parseInt($("#fillter_min").attr('min'));
        }else{
          var min = parseInt($("#fillter_min").val());
        }
        if($(data).find("#fillter_max").val() == ''){
          var max = parseInt($("#fillter_max").attr('max'));
        }else{
          var max = parseInt($("#fillter_max").val());
        }
        var def_min = parseInt($("#fillter_min").attr('min'));
        var def_max = parseInt($("#fillter_max").attr('max'));
        // slider(min,max,def_min,def_max);
        $('.results--container img[data-rimg="lazy"]').each(function () {
            $(this).attr('srcset', $(this).attr('src'));
            $(this).attr('data-rimg', 'loaded');
        });
        reinitializeProductCards();
        },
        error: function() {
        }
      };
      $.ajax(paramsup);
      return false;   
    });

    function reinitializeProductCards() {

      /* Hover visible class */
      $('.productgrid--item').off('mouseenter.productHover');
      $('.productgrid--item').off('mouseleave.productHover');

      $('.productgrid--item').on('mouseenter.productHover', function () {
        $(this).addClass('visible');
      });

      $('.productgrid--item').on('mouseleave.productHover', function () {
        $(this).removeClass('visible');
      });
      $(document).trigger('theme:section:load');
    }

});
     
